import React from 'react';
import './Features.css';
import aiAuthentication from '../assets/images/ai-authentication.png';

const Features = () => {
  return (
    <section className="features section">
      <div className="features-container">
        <div className="features-header">
          <h2 className="feature-main-title">Unlock the Full <span className='potential'>Potential</span></h2>
        </div>
        
        <div className="features-grid">
          {/* Feature 1 - AI Authentication */}
          <div className="feature-card gradient-bg-1 blur-effect">
            <div className="feature-background">
              <div className="feature-overlay"></div>
            </div>
            <div className="feature-visual">
              <div className="ai-visual">
                <img src={aiAuthentication} alt="AI Authentication" className="ai-image" />
                <div className="ai-network">
                  <div className="network-circle main-circle"></div>
                  <div className="network-dots">
                    {[...Array(16)].map((_, i) => (
                      <div key={i} className={`dot dot-${i + 1}`}></div>
                    ))}
                  </div>
                  <div className="network-lines">
                    <svg viewBox="0 0 248 248" className="network-svg">
                      <path d="M23.4 20.59L221.33 220.86" stroke="#30D96E" strokeWidth="1" />
                      <path d="M42.11 61.3L204.95 164.71" stroke="#30D96E" strokeWidth="1" />
                      <path d="M67.85 81.42L178.75 163.31" stroke="#30D96E" strokeWidth="1" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="feature-content">
              <h3 className="feature-title">Transforming Authenticity in the Luxury Market</h3>
              <p className="feature-description">
                Advanced AI solutions for identifying, authenticating, and appraising luxury goods—empowering 
                brands, resellers, and marketplaces to stay ahead.
              </p>
              <a href="#access" className="btn btn-outline feature-btn">
                Get Access
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M1.67 10H16.67M10 3.33L16.67 10L10 16.67" stroke="#007F88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Feature 2 - Live Streaming */}
          <div className="feature-card gradient-bg-2 blur-effect">
            <div className="feature-content">
              <h3 className="feature-title">Live Stream with Real-Time Auctions</h3>
              <p className="feature-description">
                Stream live and auction products in real time, allowing viewers to engage and place bids instantly. 
                Perfect for creating an interactive shopping experience that drives excitement and immediate sales.
              </p>
              <a href="#access" className="btn btn-outline feature-btn">
                Get Access
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M1.67 10H16.67M10 3.33L16.67 10L10 16.67" stroke="#007F88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Feature 3 - Profile Creation */}
          <div className="feature-card gradient-bg-3 blur-effect">
            <div className="feature-content">
              <h3 className="feature-title">Profile Creation with Selling Features</h3>
              <p className="feature-description">
                Create a personalized profile that integrates selling capabilities. Display and manage items for sale 
                directly from your profile, with an intuitive layout that keeps your followers informed and engaged.
              </p>
              <a href="#access" className="btn btn-outline feature-btn">
                Get Access
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M1.67 10H16.67M10 3.33L16.67 10L10 16.67" stroke="#9C3FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
